import { ChangeDetectorRef, Directive, ElementRef, Input, KeyValueDiffers } from '@angular/core';
import { MarkdownHoodClass } from './ngx-markdown.class';
import { MarkdownService } from './ngx-markdown.service';
export class MarkdownDirective extends MarkdownHoodClass {
    constructor(el, markdownService, changeDetectorRef, keyValueDiffers) {
        super(markdownService, changeDetectorRef, keyValueDiffers);
        this.el = el;
        this.markdownService = markdownService;
        this.changeDetectorRef = changeDetectorRef;
        this.keyValueDiffers = keyValueDiffers;
        this.directive = true;
    }
    set ngxmarkdown(value) {
        this.string = value;
    }
    get value() {
        return this.string;
    }
    ngAfterViewInit() {
        if (!this.string) {
            this.storeNgContent();
            this.change = true;
        }
    }
    ngDoCheck() {
        let changes = null;
        changes = this.differ.options.diff(this.options);
        if (changes) {
            changes.forEachChangedItem((record) => {
                if (this.options) {
                    this.options[record.key] = record.currentValue;
                    this.change = true;
                }
            });
        }
    }
    ngOnChanges(changes) {
        this.onChanges(['callback', 'ngxmarkdown'], changes);
    }
}
MarkdownDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ngxmarkdown]'
            },] },
];
MarkdownDirective.ctorParameters = () => [
    { type: ElementRef, },
    { type: MarkdownService, },
    { type: ChangeDetectorRef, },
    { type: KeyValueDiffers, },
];
MarkdownDirective.propDecorators = {
    'ngxmarkdown': [{ type: Input, args: ['ngxmarkdown',] },],
};
//# sourceMappingURL=ngx-markdown.directive.js.map